export default __webpack_public_path__ + "static/IOVideo-1b4870e85a2347ed3a9ada3c90bb4083.webm";